import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const CoffeeIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ width = 16, height = 16, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={width}
        height={height}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M2 9.33333C2.55333 9.76133 3.38467 10.0113 4.33333 10C5.282 10.0113 6.11333 9.76133 6.66667 9.33333C7.22 8.90533 8.05133 8.65533 9 8.66667C9.94867 8.65533 10.78 8.90533 11.3333 9.33333M5.33332 2C5.12232 2.15145 4.95137 2.35198 4.83522 2.58428C4.71907 2.81658 4.66121 3.07367 4.66665 3.33333C4.66121 3.593 4.71907 3.85008 4.83522 4.08238C4.95137 4.31469 5.12232 4.51522 5.33332 4.66667M7.99998 2C7.78899 2.15145 7.61803 2.35198 7.50188 2.58428C7.38573 2.81658 7.32788 3.07367 7.33332 3.33333C7.32788 3.593 7.38573 3.85008 7.50188 4.08238C7.61803 4.31469 7.78899 4.51522 7.99998 4.66667M11.164 11.1507C11.4617 11.2873 11.7885 11.3488 12.1155 11.3296C12.4425 11.3104 12.7599 11.2112 13.0396 11.0406C13.3193 10.8701 13.5528 10.6335 13.7197 10.3515C13.8865 10.0696 13.9815 9.75095 13.9963 9.42368C14.0112 9.09641 13.9454 8.7705 13.8048 8.47461C13.6642 8.17872 13.453 7.9219 13.1899 7.72672C12.9268 7.53155 12.6198 7.40399 12.2958 7.35528C11.9718 7.30656 11.6409 7.33817 11.332 7.44733M2 6.66667H11.3333V10C11.3333 11.0609 10.9119 12.0783 10.1618 12.8284C9.41161 13.5786 8.3942 14 7.33333 14H6C4.93913 14 3.92172 13.5786 3.17157 12.8284C2.42143 12.0783 2 11.0609 2 10V6.66667Z"
          stroke="#1677FF"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
